import { Constants } from "./Constants";
import { LocalStorageHelper } from "./LocalStorageHelper";

export class LocalTokenHelper {
    // Saves the login and refresh tokens to local storage and the RestHelper cached static properties.
    static saveLoginTokens = function(token: string, refreshToken: string) {
        LocalStorageHelper.save(Constants.UserLocalStorageTokenKey, token);
        LocalStorageHelper.save(Constants.UserLocalStorageRefreshTokenKey, refreshToken);
    }

    // Deletes the specified value from local storage and clears the RestHelper cached static properties.
    static logOutUser = function() {
        LocalStorageHelper.delete(Constants.UserLocalStorageTokenKey);
        LocalStorageHelper.delete(Constants.UserLocalStorageRefreshTokenKey);
    }

    // Gets the user login token from local storage. Will return null if the user is not logged in.
    static getLoginToken = function() {
        return LocalStorageHelper.load(Constants.UserLocalStorageTokenKey);
    }

    // Gets the user refresh token from local storage. Will return null if the user is not logged in.
    static getRefreshToken = function() {
        return LocalStorageHelper.load(Constants.UserLocalStorageRefreshTokenKey);
    }
}